module.exports = __webpack_public_path__ + "img/atlas-bg.aaa83554.webp";